import type { CreatePriceTableFormData } from '@/schemas/commercial/price-table.schema';

/** Condition shape used by the price table form (billingLimitInCents as pt-BR string). */
export type BillingConditionFormData =
  CreatePriceTableFormData['groups'][number]['conditions'][number];

/** Condition group shape used by the price table form. */
export type BillingConditionGroupFormData = CreatePriceTableFormData['groups'][number];

const uid = () => crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2);

/**
 * Single source of truth for the initial values of a billing condition.
 * Keep in sync with `priceTableConditionSchema` — every form field must be
 * initialized here so new fields are added in exactly one place.
 */
export const createEmptyBillingCondition = (): BillingConditionFormData => ({
  id: uid(),
  salesFor: [],
  billingLimitInCents: '',
  toBillFor: '',
  icmsContributor: null,
});

/**
 * Single source of truth for the initial values of a billing condition group.
 * A group always starts with exactly one empty condition and priority disabled.
 */
export const createEmptyBillingConditionGroup = (): BillingConditionGroupFormData => ({
  id: uid(),
  conditions: [createEmptyBillingCondition()],
  priority: false,
});

export { validatePriceTableConditions } from '@bcube/core/validators';
